<template>
  <div class="datetime-display">
    {{ dateTimeString }}
  </div>
</template>

<script>
export default {
  name: 'DigitalClock',
  data() {
    return {
      dateTimeString: '',
      intervalId: null,
    };
  },
  methods: {
    updateTime() {
      const now = new Date();
      // Format: 10:30 PM | Thursday, 26 September 2025
      const timeOptions = { hour: '2-digit', minute: '2-digit', hour24: true };
      const dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      
      const time = new Intl.DateTimeFormat('en-GB', timeOptions).format(now);
      const date = new Intl.DateTimeFormat('en-GB', dateOptions).format(now);

      this.dateTimeString = `${time} | ${date}`;
    },
  },
  mounted() {
    this.updateTime();
    this.intervalId = setInterval(this.updateTime, 1000);
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  },
};
</script>

<style scoped>
/* A clean, professional, and non-retro style */
.datetime-display {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 15px;
  font-weight: 500; /* medium weight */
  color: #D91C5E; /* text-pink-600 */
  white-space: nowrap; /* Prevent wrapping */
}
</style>